export const IMAGES = {
    boardroom:
        'https://images.unsplash.com/photo-1764810815228-b7f9432eec5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxicmlnaHQlMjBtb2Rlcm4lMjBleGVjdXRpdmUlMjBib2FyZHJvb20lMjBtZWV0aW5nJTIwZGF5bGlnaHR8ZW58MHx8fHwxNzkxMTYyOTQyfDA&ixlib=rb-4.1.0&q=85',
    conference:
        'https://images.unsplash.com/photo-1517502884422-41eaead166d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBjb25mZXJlbmNlJTIwcm9vbSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTExNjI5NDJ8MA&ixlib=rb-4.1.0&q=85',
    podium:
        'https://images.unsplash.com/photo-1715610237622-748477adf2e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxwcmVzcyUyMGNvbmZlcmVuY2UlMjBtaWNyb3Bob25lcyUyMHBvZGl1bSUyMHNwZWVjaHxlbnwwfHx8fDE3OTExNjI5NDZ8MA&ixlib=rb-4.1.0&q=85',
    skyline:
        'https://images.unsplash.com/photo-1595367864470-cedf8e27e988?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjaXR5JTIwc2t5bGluZSUyMGRheWxpZ2h0JTIwYnJpZ2h0JTIwYmx1ZSUyMHNreXxlbnwwfHx8fDE3OTExNjI5NDJ8MA&ixlib=rb-4.1.0&q=85',
    skyscraper:
        'https://images.unsplash.com/photo-1617761141732-d481912af1a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBza3lzY3JhcGVyJTIwYXJjaGl0ZWN0dXJlJTIwYnJpZ2h0JTIwZGF5bGlnaHR8ZW58MHx8fDE3OTExNjI5NDJ8MA&ixlib=rb-4.1.0&q=85',
};

export const SERVICES = [
    {
        id: 'media',
        testId: 'service-card-media',
        title: 'Media Relations & Strategic Communications',
        desc: 'Editorial board access, broadcast placement, and narrative engineering across tier-one global outlets.',
    },
    {
        id: 'adoption',
        testId: 'service-card-adoption',
        title: 'Market Adoption Strategy',
        desc: 'C-suite counsel to identify target adoption markets and corporate development goals — and programs to reach them.',
    },
    {
        id: 'ppp',
        testId: 'service-card-ppp',
        title: 'Public-Private Partnerships',
        desc: 'Structuring coalitions between government, institutions, and enterprise to unlock regulated and emerging markets.',
    },
    {
        id: 'visibility',
        testId: 'service-card-visibility',
        title: 'Executive & Media Visibility',
        desc: 'Keynote placement, thought leadership platforms, and profile architecture for principals and boards.',
    },
    {
        id: 'events',
        testId: 'service-card-events',
        title: 'Event Participation & Activation',
        desc: 'On-the-ground representation, delegation management, and activation at the summits that matter.',
    },
    {
        id: 'leadgen',
        testId: 'service-card-leadgen',
        title: 'Lead Generation at Scale',
        desc: 'Programs that convert media reach, partnerships, and industry engagement into qualified pipeline.',
    },
];

export const MARQUEE_ITEMS = [
    'Media Relations',
    'Market Adoption',
    'Public–Private Partnerships',
    'Executive Visibility',
    'Event Activation',
    'Lead Generation',
    'Strategic Advisory',
    'Stakeholder Influence',
];

export const INTERESTS = [
    'Media Relations',
    'Market Adoption Strategy',
    'Public-Private Partnerships',
    'Executive & Media Visibility',
    'Event Participation & Activation',
    'Lead Generation Programs',
    'General Inquiry',
];
